import { AlertTriangle, MessageSquare, PhoneCall } from "lucide-react";
import {
  STAGES, ageSince, isAwaitingApproval, money, outstanding,
  quoteLabel, stageOf, vehicleLabel, workLabel,
} from "./advisorUtils";

// One car in the Advisor Desk list. Deliberately tall (min 92px) so it's a
// comfortable thumb target on an iPad and readable at arm's length.
export const AdvisorCarRow = ({ job, selected, onSelect, showWait, flash }) => {
  const stage = STAGES[stageOf(job)];
  const urgent = job.schedule_urgency === "red";
  const waiting = showWait ? ageSince(job.viewed_at || job.sent_at) : null;
  const unread = (job.customer_messages || []).filter((m) => m.from === "customer" && !m.read_at).length;
  const callbacks = (job.callback_requests || []).filter((c) => !c.resolved_at).length;

  return (
    <button
      type="button"
      onClick={() => onSelect(job)}
      data-testid={`advisor-car-row-${job.id}`}
      data-flash={flash ? "true" : undefined}
      className={`w-full text-left px-4 py-3.5 min-h-[92px] rounded-xl border transition-colors duration-150 flex items-center gap-4 ${
        flash ? "ring-2 ring-emerald-400 animate-pulse " : ""
      }${
        selected
          ? "bg-emerald-500/10 border-emerald-500/60"
          : "bg-slate-900/60 border-slate-800 hover:bg-slate-800/80 active:bg-slate-800"
      }`}
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2.5">
          <span className="font-mono font-black text-xl tracking-wider text-slate-100" data-testid={`advisor-row-reg-${job.id}`}>
            {job.vehicle_reg || "NO REG"}
          </span>
          {urgent && <AlertTriangle className="w-4 h-4 text-red-400 shrink-0" />}
          {unread > 0 && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-sky-500/20 text-sky-300 text-[11px] font-bold">
              <MessageSquare className="w-3 h-3" /> {unread}
            </span>
          )}
          {callbacks > 0 && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-300 text-[11px] font-bold">
              <PhoneCall className="w-3 h-3" /> Call back
            </span>
          )}
        </div>
        <div className="text-base font-semibold text-slate-200 truncate mt-0.5">
          {job.customer_name || "Customer"}
          <span className="text-slate-500 font-normal"> · {vehicleLabel(job)}</span>
        </div>
        <div className="text-sm text-slate-400 truncate">{workLabel(job)}</div>
      </div>

      <div className="text-right shrink-0 space-y-1">
        <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-800 text-xs font-bold ring-1 ${stage.ring} ${stage.text}`}>
          <span className={`w-2 h-2 rounded-full ${stage.dot}`} /> {stage.label}
        </div>
        <div className="font-mono text-sm text-slate-300 tabular-nums">
          Out {job.promised_ready_time || "—"}
        </div>
        {waiting ? (
          <div className="text-xs font-bold text-amber-300">{waiting} waiting</div>
        ) : (
          <div className="text-xs text-slate-500">{quoteLabel(job)}</div>
        )}        {isAwaitingApproval(job) && outstanding(job) > 0 && (
          <div className="text-xs font-bold text-slate-200">{money(outstanding(job))} out</div>
        )}
      </div>
    </button>
  );
};
